module.exports = __webpack_public_path__ + "img/02_mo.ad840c0c.jpg";